module.exports = __webpack_public_path__ + "static/media/feature.399d04dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Harvey/feature.jpg
// module id = 303
// module chunks = 0